import CartUpsellProduct from './CartUpsellProduct';
import { fetchProduct } from '../helpers/queries';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

import {
  getIdfromGid,
  getTranslation,
  mapEdgesToNodes,
} from '../helpers/utilities';
import { useEffect, useState } from 'preact/hooks';

const CartUpsell = () => {
  const { cart, isMiniCartOpen } = useCartContext();
  const [productIds, setProductIds] = useState([]);
  const [upsells, setUpsells] = useState([]);
  const [upsellItems, setUpsellItems] = useState([]);

  useEffect(() => {
    if (isMiniCartOpen && cart && cart.items.length > 0) {
      const allUpsellHandles = cart.items
        .map(item => item.upsell_item)
        .filter(item => item);
      const uniqueUpsellHandles = allUpsellHandles.filter((item, pos) => {
        return allUpsellHandles.indexOf(item) == pos;
      });
      setProductIds(cart.items.map(item => item.product_id));

      setUpsells([]);
      uniqueUpsellHandles.forEach(handle => {
        fetchProduct(handle).then(({ data }) => {
          const upsell = {
            id: getIdfromGid(data.product.id),
            title: data.product.title,
            handle: data.product.handle,
            options: data.product.options,
            primary_color: data.product.options[0].values[0],
            variants: mapEdgesToNodes(data.product.variants),
            images: mapEdgesToNodes(data.product.images),
            price: data.product.priceRange,
            vendor: data.product.vendor,
          };

          setUpsells(prev => [...prev, upsell]);
        });
      });
    }
  }, [cart.items, isMiniCartOpen]);

  useEffect(() => {
    if (isMiniCartOpen == true) {
      const filteredUpsells = upsells.filter(
        upsell => !productIds.includes(upsell.id),
      );
      setUpsellItems(filteredUpsells);
    }
  }, [upsells, isMiniCartOpen]);

  return upsellItems && upsellItems.length > 0 ? (
    <div class="relative pb-8 pt-3">
      <p class="type-nav-item mb-4 font-bold uppercase">
        {getTranslation('mini_cart.complete_order')}
      </p>
      <div class="hide-scrollbar flex snap-mandatory overflow-x-auto scroll-smooth">
        {(upsellItems || []).map(item => (
          <CartUpsellProduct product={item} />
        ))}
      </div>
    </div>
  ) : null;
};

export default CartUpsell;
